import { render, staticRenderFns } from "./SetRole.vue?vue&type=template&id=607b0393&scoped=true&"
import script from "./SetRole.vue?vue&type=script&lang=js&"
export * from "./SetRole.vue?vue&type=script&lang=js&"
import style0 from "./SetRole.vue?vue&type=style&index=0&id=607b0393&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607b0393",
  null
  
)

export default component.exports